import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/chart-bar': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M396.8 352H419.2C425.6 352 432 345.6 432 339.2V108.8C432 102.4 425.6 96 419.2 96H396.8C390.4 96 384 102.4 384 108.8V339.2C384 345.6 390.4 352 396.8 352zM204.8 352H227.2C233.6 352 240 345.6 240 339.2V140.8C240 134.4 233.6 128 227.2 128H204.8C198.4 128 192 134.4 192 140.8V339.2C192 345.6 198.4 352 204.8 352zM300.8 352H323.2C329.6 352 336 345.6 336 339.2V204.8C336 198.4 329.6 192 323.2 192H300.8C294.4 192 288 198.4 288 204.8V339.2C288 345.6 294.4 352 300.8 352zM496 400H48V80C48 71.2 40.8 64 32 64H16C7.2 64 0 71.2 0 80V416C0 433.7 14.3 448 32 448H496C504.8 448 512 440.8 512 432V416C512 407.2 504.8 400 496 400zM108.8 352H131.2C137.6 352 144 345.6 144 339.2V268.8C144 262.4 137.6 256 131.2 256H108.8C102.4 256 96 262.4 96 268.8V339.2C96 345.6 102.4 352 108.8 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/chart-bar.js
// module id = EhjZ
// module chunks = 144